import { doc, collection } from 'firebase/firestore';
import { db } from '../../../firebase-config';

/** Per-school populated accreditation schema (v2). */
export const SCHOOL_SCHEMAS_COLLECTION = 'schoolSchemas';

/** Current evidence analysis job per school (v2 progress board). */
export const EVIDENCE_ANALYSIS_JOBS_COLLECTION = 'evidenceAnalysisJobs';

export function schoolSchemaRef(schoolId) {
  return doc(db, SCHOOL_SCHEMAS_COLLECTION, schoolId);
}

export function evidenceAnalysisJobRef(schoolId) {
  return doc(db, EVIDENCE_ANALYSIS_JOBS_COLLECTION, schoolId);
}

export function evidenceAnalysisJobsCollection() {
  return collection(db, EVIDENCE_ANALYSIS_JOBS_COLLECTION);
}